import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function getCaneca() {
  const data = await api.get(`${URLS.CANECA}`)
  .then((resp) => resp?.data);

  return data;
}
